import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const HeroContainer = styled.section`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 5%;
  position: relative;
  overflow: hidden;
  text-align: center;
`;

const SplineContainerBackground = styled.div`
  /* position: absolute;
  top: 0;
  left: 0; */
  padding-top: 10vh;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;

  iframe {
    width: 100%;
    height: 40vh;
    border: none;
  }
`;

const Content = styled.div`
  max-width: 800px;
  z-index: 10;
  /* margin-top: 20vh; */
`;

const Title = styled.h1`
  margin-bottom: 1.5rem;
  font-weight: 800;
  font-size: clamp(3rem, 6vw, 5rem);

  span {
    color: var(--secondary);
  }
`;

const Description = styled.p`
  color: #fff;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 2rem;
  line-height: 1.6;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const SubText = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 1rem;
  margin-top: 4rem;
`;

export const Hero: React.FC = () => {
  const { t } = useTranslation();
  return (
    <HeroContainer>
      <SplineContainerBackground>
        <iframe
          src="https://my.spline.design/betpilotcopy-c947ff5fc5de56668ecd66b5f0d70854/"
          title="Spline 3D"
        />
      </SplineContainerBackground>
      <Content>
        <Title>
          {t("hero.title_part1")}
          <span>{t("hero.title_part2")} </span> {t("hero.title_part3")}
        </Title>
        <Description>
          {String(t("hero.description"))
            .split("\n")
            .map((line: string, i: number) => (
              <React.Fragment key={i}>
                {line}
                <br />
              </React.Fragment>
            ))}
        </Description>
        <SubText>{t("hero.subtext")}</SubText>
      </Content>
    </HeroContainer>
  );
};

